import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('./views/Home/Home.vue')
    },
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About/About.vue')
    },
    {
      path: '/group-overview',
      name: 'GroupOverview',
      component: () => import('./views/About/GroupOverview.vue')
    },
    {
      path: '/chairman-message',
      name: 'ChairmanMessage',
      component: () => import('./views/About/ChairmanMessage.vue')
    },
    {
      path: '/contact-us',
      name: 'ContactUs',
      component: () => import('./views/About/ContactUs.vue')
    },
    {
      path: '/recruit',
      name: 'Recruit',
      component: () => import('./views/About/Recruit.vue')
    },
    {
      path: '/recruit-detail/:id',
      name: 'RecruitDetail',
      component: () => import('./views/About/RecruitDetail.vue')
    },
    {
      path: '/case-sharing',
      name: 'CaseSharing',
      component: () => import('./views/Case/CaseSharing.vue')
    },
    {
      path: '/platform-services',
      name: 'PlatformServices',
      component: () => import('./views/Case/PlatformServices.vue')
    },
    {
      path: '/training-service',
      name: 'TrainingService',
      component: () => import('./views/Case/TrainingService.vue')
    },
    {
      path: '/training-service-detail/:id',
      name: 'TrainingServiceDetail',
      component: () => import('./views/Case/TrainingServiceDetail.vue')
    },
    {
      path: '/meeting',
      name: 'Meeting',
      component: () => import('./views/Case/Meeting.vue')
    },
    {
      path: '/service',
      name: 'Service',
      component: () => import('./views/Service/Service.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})
